import { ConsultantDocOnlineService } from "../../../../services/DOCOnlineService";
import { ConsultantCommonService } from "../../../../services/CommonService";

export function ConsultantDocOnlineCtr(props) {
  let consultantDocOnlineService = ConsultantDocOnlineService(
    props.match.params.docOnlineticket
  );
  return {
    getDocOnline() {
      return consultantDocOnlineService
        .getConsultantDocOnline()
        .then((data) => {
          return data;
        });
    },
    saveAs(docOnline) {
      return consultantDocOnlineService.saveAs(docOnline).then((data) => {
        return data;
      });
    },
    save(docOnline) {
      return consultantDocOnlineService.save(docOnline).then((data) => {
        return data;
      });
    },
    generateUrl(languageId, companyId) {
      return consultantDocOnlineService
        .generateUrl(languageId, companyId)
        .then((data) => {
          return data;
        });
    },
    downloadDocOnline(templatePrefix, languageCode, downloadIsInPdf, fileName) {
      return consultantDocOnlineService
        .downloadDocOnline(
          templatePrefix,
          languageCode,
          downloadIsInPdf,
          fileName
        )
        .then((data) => {
          return data;
        });
    },
    docOnlineService: consultantDocOnlineService,
    commonService: ConsultantCommonService(props.match.params.docOnlineticket)
  };
}
